import { NgModule } from '@angular/core';
import { LetDirective } from './directives/let.directive';

@NgModule({
    imports: [],
    exports: [LetDirective],
    declarations: [LetDirective],
    providers: [],
})
export class IM2MCommonModule {}
